<template>
    <form action="">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ capitalize(model) }} Version</p>
            </header>
            <section class="modal-card-body">
                <p class="mb-3">This {{ model }} needs to be versioned before an edit can be made.</p>

                <slot name="preview" />

                <p class="mt-3">Do you want to create a new version now?</p>
            </section>
            <footer class="modal-card-foot tw:flex tw:gap-2">
                <e-button :disabled="isSaving" label="Go Back" @click="$emit('close')" />
                <e-button :disabled="isSaving" label="Create Version" type="is-primary" @click="version()" />
            </footer>
        </div>
    </form>
</template>

<script>
import capitalize from 'lodash/capitalize.js';

export default {
    name: 'VersionModalForm',

    emits: ['close', 'version'],

    props: {
        apiRoute: {
            type: String,
            required: true,
        },
        model: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        isSaving: false,
    }),

    methods: {
        capitalize,
        version() {
            this.isSaving = true;
            this.$emit('version');
        },
    },
};
</script>
